import { Theme, useCacheToken, useStyleRegister } from '@ant-design/cssinjs';
import React from 'react';
import version from '../version';
import { PresetColors } from './interface';
import defaultDerivative from './themes/default';
import defaultSeedToken from './themes/seed';
import { clearFix, operationUnit, resetComponent, resetIcon, roundedArrow } from './util';
import formatToken from './util/alias';
import genComponentStyleHook from './util/genComponentStyleHook';
import getArrowStyle from './util/placementArrow';
import statisticToken, { merge as mergeToken, statistic } from './util/statistic';
const defaultTheme = new Theme(defaultDerivative);
export { resetComponent, resetIcon, clearFix, roundedArrow, getArrowStyle, operationUnit, 
// colors
PresetColors, 
// Statistic
statistic, statisticToken, mergeToken, 
// hooks
useStyleRegister, genComponentStyleHook, };
// ================================ Context =================================
export const DesignTokenContext = React.createContext({
    token: defaultSeedToken,
});
// ================================== Hook ==================================
// In dev env, we refresh salt per hour to avoid user use this
// Note: Do not modify this to real time update which will make debug harder
const saltPrefix = process.env.NODE_ENV === 'production' ? version : `${version}-${new Date().getHours()}`;
export function useToken() {
    const { token: rootDesignToken, override, hashed, theme } = React.useContext(DesignTokenContext);
    const salt = `${saltPrefix}-${hashed || ''}`;
    const mergedTheme = theme || defaultTheme;
    const [token, hashId] = useCacheToken(mergedTheme, [defaultSeedToken, rootDesignToken], {
        salt,
        override,
        formatToken,
    });
    return [mergedTheme, token, hashed ? hashId : ''];
}
